module.exports = __webpack_public_path__ + "static/media/SuraSans-Regular.f160ab57.woff2";